interface IVariables {
    vars: Record<string, string>;
}

let staticCssVariablesApplied = false;

function applyPrefixedCssVariables (prefixedVars: Record<string, string>): void {
    const rootStyle = document.documentElement.style;
    Object.entries(prefixedVars).forEach(([varKey, value]) => {
        rootStyle.setProperty(varKey, value);
    });
}

function buildCSSVariables (variables: IVariables): void {
    applyPrefixedCssVariables(variables.vars);
}

function applyStaticCssVariables (variables: IVariables): void {
    applyPrefixedCssVariables(variables.vars);
    staticCssVariablesApplied = true;
}

function applyThemeCssVariables (variables: IVariables): void {
    applyPrefixedCssVariables(variables.vars);
}

function resetStaticCssVariablesState (): void {
    staticCssVariablesApplied = false;
}

function hasAppliedStaticCssVariables (): boolean {
    return staticCssVariablesApplied;
}

function addVariablePrefix (newVariablesObj: Record<string, string>): Record<string, string> {
    const newObj: Record<string, string> = {};
    Object.entries(newVariablesObj).forEach(([key, val]) => {
        newObj[`--${key}`] = val;
    });
    return newObj;
}

export {
    buildCSSVariables,
    applyStaticCssVariables,
    applyThemeCssVariables,
    resetStaticCssVariablesState,
    hasAppliedStaticCssVariables,
    addVariablePrefix,
};
